import { Sparkles, Type, Heart, History, Crown, ChevronLeft } from "lucide-react";
import { BannerCarousel } from "./BannerCarousel";

const MENU_ITEMS = [
  {
    key: "templates",
    icon: Sparkles,
    filled: false,
    title: "إنشاء من قالب",
    subtitle: "اختر قالب متحرك وأضف اسمك عليه",
    vip: false,
  },
  {
    key: "textOnly",
    icon: Type,
    filled: false,
    title: "نص بدون قالب",
    subtitle: "ملصق نصي بخلفية شفافة بالكامل",
    vip: false,
  },
  {
    key: "favorites",
    icon: Heart,
    filled: true,
    title: "القوالب المفضلة",
    subtitle: "القوالب اللي علّمتها كمفضّلة",
    vip: false,
  },
  {
    key: "recent",
    icon: History,
    filled: false,
    title: "آخر المشاريع",
    subtitle: "آخر 3 مشاريع · تبقى 3 أيام",
    vip: true,
  },
] as const;

export function CreateMenu({
  onTemplates,
  onTextOnly,
  onFavorites,
  onRecent,
}: {
  onTemplates: () => void;
  onTextOnly: () => void;
  onFavorites: () => void;
  onRecent: () => void;
}) {
  const handlers: Record<string, () => void> = {
    templates: onTemplates,
    textOnly: onTextOnly,
    favorites: onFavorites,
    recent: onRecent,
  };

  return (
    <div className="h-full overflow-y-auto p-5 flex flex-col gap-5">
      <div className="mt-3 mb-1">
        <h1 className="text-2xl font-bold tracking-tight">إنشاء ملصق</h1>
        <p className="text-sm text-tg-hint mt-1">اختر طريقة البداية</p>
      </div>

      <BannerCarousel />

      <div className="flex flex-col gap-3">
        {MENU_ITEMS.map(({ key, icon: Icon, filled, title, subtitle, vip }) => (
          <button
            key={key}
            type="button"
            onClick={handlers[key]}
            className="flex items-center gap-4 p-4 text-right rounded-2xl bg-white/[0.04] border border-white/10 active:bg-white/[0.07] transition-colors"
          >
            <span className="w-12 h-12 rounded-2xl bg-white/5 border border-white/10 flex items-center justify-center shrink-0">
              <Icon className="text-tg-text" size={22} strokeWidth={2.25} fill={filled ? "currentColor" : "none"} />
            </span>
            <span className="flex-1 min-w-0">
              <span className="flex items-center gap-2 font-bold text-tg-text">
                {title}
                {vip && (
                  <span
                    className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded-md text-[10px] font-bold"
                    style={{ background: "rgba(59,130,246,.18)", color: "#8FB4FF", border: "1px solid rgba(59,130,246,.35)" }}
                  >
                    <Crown size={10} strokeWidth={2.5} />
                    VIP
                  </span>
                )}
              </span>
              <span className="block text-sm text-tg-hint truncate">{subtitle}</span>
            </span>
            <ChevronLeft className="text-tg-hint shrink-0" size={18} strokeWidth={2.25} />
          </button>
        ))}
      </div>
    </div>
  );
}
